import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./store";

const EditCtx = createContext(null);
export const useEdit = () => useContext(EditCtx) || { get: (_k, d) => d, isOwner: false, editMode: false };

const token = () => sessionStorage.getItem("rj_admin_token") || "";
const authHeader = () => ({ Authorization: `Bearer ${token()}` });

export function EditProvider({ children }) {
  const [content, setContent] = useState({});
  const [isOwner, setIsOwner] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/content`);
      setContent(r.data || {});
    } catch (e) {
      console.warn("content fetch failed:", e?.message);
    }
  }, []);

  const checkOwner = useCallback(async () => {
    if (!token()) { setIsOwner(false); return; }
    try {
      const r = await axios.get(`${API}/admin/whoami`, { headers: authHeader() });
      setIsOwner(Boolean(r.data?.ok) && r.data?.role === "admin");
    } catch { setIsOwner(false); }
  }, []);

  useEffect(() => { refresh(); checkOwner(); }, [refresh, checkOwner]);
  useEffect(() => {
    const h = () => checkOwner();
    window.addEventListener("rj-admin-auth", h);
    return () => window.removeEventListener("rj-admin-auth", h);
  }, [checkOwner]);

  const get = useCallback((key, def = "") => {
    const v = content[key];
    return v === undefined || v === null || v === "" ? def : v;
  }, [content]);

  const save = useCallback(async (key, value, type = "text", prev = undefined) => {
    const r = await axios.post(`${API}/admin/content`, { key, value, type, prev }, { headers: authHeader() });
    setContent((m) => ({ ...m, [key]: value }));
    return r.data;
  }, []);

  const undo = useCallback(async (key) => {
    const r = await axios.post(`${API}/admin/content/undo`, { key }, { headers: authHeader() });
    setContent((m) => {
      const next = { ...m };
      if (r.data.deleted) delete next[key];
      else next[key] = r.data.value;
      return next;
    });
    return r.data;
  }, []);

  return (
    <EditCtx.Provider value={{ content, get, save, undo, refresh, isOwner, editMode, setEditMode, authHeader }}>
      {children}
    </EditCtx.Provider>
  );
}
